import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../../core/services/app-config.service';
import { AuthStoreService } from '../../shared/services/auth/auth-store.service';
import { TokenService } from '../services/token.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private appConfig: AppConfig,
    private authService: AuthStoreService,
    private tokenService: TokenService,
  ) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url) {
      return next.handle(req);
    }

    const url = req.url.toLowerCase();
    const token = this.tokenService.getToken();
    return this.checkUrl(url) && !!token
      ? next.handle(
          req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          }),
        )
      : next.handle(req);
  }

  private checkUrl(url: string): boolean {
    return !!(
      this.appConfig.config &&
      this.appConfig.config.wsUrl &&
      this.appConfig.config.apiUrl &&
      [this.appConfig.config.apiUrl, this.appConfig.config.authUrl, this.appConfig.config.wsUrl].find((u) =>
        url.startsWith(u),
      )
    );
  }
}
